import { Fragment } from 'react';
import '../style.css';
import ayalolooBuses from '../../../assets/ayaloloo-buses.png';
import monitorBus from '../../../assets/monitor-bus.png';
import betterPayment from '../../../assets/better-payment.jpg';
import AllStoresBtn from '../../../components/StoreButton/AllStoresBtn';
import DownloadPanel from '../../../components/DownloadPanel/DownloadPanel';
import Step from '../../../components/Steps/Step';
import SplitHero from '../../../components/SplitHero/SplitHero';

const EVBuses = () => {
  const steps = [
    {
      title: 'Sign up',
      description:
        "Download the Tap n' Go app and register your account to access BRT and EV bus routes near you.",
    },
    {
      title: 'Track & Plan',
      description:
        'See your BRT bus in real-time, check live schedules, and find the nearest stop.',
    },
    {
      title: 'Tap in',
      description:
        "Use your Tap n' Go card for quick, contactless payment as you board — zero cash, zero hassle.",
    },
  ];

  return (
    <Fragment>
      <SplitHero
        image={ayalolooBuses}
        imageAlt="BRT EV buses"
        title="BRT / EV Buses"
        subtitle="Cleaner, smarter bus transit. Hop on a BRT or electric bus and travel the city effortlessly with Tap n' Go."
      >
        <AllStoresBtn />
      </SplitHero>

      <section>
        <div className="content__wrapper secondary">
          <div className="content row-reverse">
            <h2>Greener Rides Across the City</h2>
            <div className="image">
              <img src={monitorBus} alt="Monitor bus routes" />
            </div>
            <div className="content__txt">
              <h2>Greener Rides Across the City</h2>
              <p className="mt-6 text-base text-subtext">
                Our BRT and EV bus network puts clean, reliable transport at
                your fingertips. Track buses live, plan your route, and board
                without fumbling for change.
              </p>
              <AllStoresBtn />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="content__wrapper">
          <div className="content">
            <h2>Seamless Contactless Payment</h2>
            <div className="image">
              <img src={betterPayment} alt="Contactless payment" />
            </div>
            <div className="content__txt">
              <h2>Seamless Contactless Payment</h2>
              <p className="mt-6 text-base text-subtext">
                No more queuing for tickets. Tap your Tap n' Go card at the
                reader and go — fast, secure, and accepted on every BRT and EV
                bus route.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="content__wrapper">
          <div className="content row-reverse">
            <h2>Get on Board with EV Buses</h2>
            <div className="image h-570">
              <img src={ayalolooBuses} alt="EV buses" />
            </div>
            <div className="content__txt">
              <h2>Get on Board with EV Buses</h2>
              <div className="mt-10 sm:mt-5">
                {steps.map((step, idx) => (
                  <Step
                    key={idx}
                    title={step.title}
                    description={step.description}
                    number={idx + 1}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

<DownloadPanel />
    </Fragment>
  );
};

export default EVBuses;
